import * as React from 'react';

const Presentation = (props: any) => {
    return(
        <div id="sobre">
            <div className="container-fluid presentation-f-block d-flex justify-content-center align-items-center ">
                <div className="text-center row col-sm-12 col-md-5 flex-column align-items-center">
                    <h1 className="texto-intro col-sm-4 col-md-4 upper bold smallest-text">Criamos soluções digitais para empresas de saúde</h1>
                    <p className="texto-intro col-sm-4 col-md-4 p-intro">Visão de negócios e tecnologia juntos para construir produtos de impacto</p>
                </div>
            </div>
        </div>
    );
};
export default Presentation;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/PresentationComponent.tsx